import { Breakpoint, BreakpointsStyles } from '@types';

export const getResponsiveStyle: (
    style: string,
    activeBreakpoint: Breakpoint,
    breakpoints: BreakpointsStyles
) => string | null = (style, activeBreakpoint, breakpoints) => {
    if (breakpoints[activeBreakpoint] && breakpoints[activeBreakpoint][style] !== undefined) {
        return breakpoints[activeBreakpoint][style];
    } else {
        const previousBreakpoint = getPreviousBreakpoint(activeBreakpoint);
        return previousBreakpoint ? getResponsiveStyle(style, previousBreakpoint, breakpoints) : null;
    }
};

const getPreviousBreakpoint: (breakpoint: Breakpoint) => Breakpoint | null = (breakpoint) => {
    switch (breakpoint) {
        case Breakpoint.xxl:
            return Breakpoint.xl;
        case Breakpoint.xl:
            return Breakpoint.lg;
        case Breakpoint.lg:
            return Breakpoint.md;
        case Breakpoint.md:
            return Breakpoint.sm;
        case Breakpoint.sm:
            return Breakpoint.xs;
        default:
            return null;
    }
};
